import { Injectable } from '@angular/core';
import { ApiService, HttpMethod } from '../common/api.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { Folder } from './folder.model';
import { FolderEditModel } from './folder-edit.model';
import { PdfAsset } from '../pdfs/pdf-asset-model';
import { UploadFileResult } from '../images/image-manager.service';

@Injectable({
    providedIn: 'root'
})
export class FolderApiService extends ApiService
{
    constructor(protected override http: HttpClient)
    {
        super(http);
    }

    getFolder(id: number): Observable<Folder>
    {
        return this.apiRequest(this.getFolderUrl(id), HttpMethod.Get).pipe(map((json: any) => new Folder(json)));
    }

    createFolder(folder: FolderEditModel): Observable<Folder>
    {
        return this.apiRequest<any>(this.createFolderUrl, HttpMethod.Post, JSON.stringify({
            Name: folder.Name,
            IsPublished: folder.IsPublished,
            ParentId: folder.ParentId,
            CategoryIds: folder.CategoryIds,
        })).pipe(map((json: any) => new Folder(json)));
    }

    updateFolder(folder: FolderEditModel): Observable<Folder>
    {
        const params = { ParentId: folder.ParentId, Id: folder.Id, Name: folder.Name, IsPublished: folder.IsPublished, CategoryIds: folder.CategoryIds };
        return this.apiRequest<any>(this.updateFolderUrl(folder.Id), HttpMethod.Put, JSON.stringify(params))
            .pipe(map((json: any) => new Folder(json)));
    }

    addPdfToFolder(folderId: number, uploadResult: UploadFileResult): Observable<PdfAsset>
    {
        return this.apiRequest<any>(this.addPdfToFolderUrl, HttpMethod.Post, JSON.stringify({
            FolderId: folderId,
            Url: uploadResult.fileOrUrl,
        })).pipe(map((json: any) => new PdfAsset(json)));
    }

    deleteFolder(folderId: number): Observable<any>
    {
        return this.apiRequest<any>(this.deleteFolderUrl(folderId), HttpMethod.Delete);
    }

    deleteItems(folderId: number, folderIdsToDelete: number[], pdfIdsToDelete: number[]): Observable<Folder>
    {
        return this.apiRequest<any>(this.deleteItemsUrl, HttpMethod.Delete, JSON.stringify({
            FolderId: folderId,
            SubFolderIds: folderIdsToDelete,
            PdfIds: pdfIdsToDelete,
        })).pipe(map((json: any) => new Folder(json)));
    }

    moveItems(destinationFolderId: number, folderIdsToMove: number[], pdfIdsToMove: number[]): Observable<Folder>
    {
        return this.apiRequest<any>(this.moveItemsUrl, HttpMethod.Post, JSON.stringify({
            FolderId: destinationFolderId,
            SubFolderIds: folderIdsToMove,
            PdfIds: pdfIdsToMove,
        })).pipe(map((json: any) => new Folder(json)));
    }

    // =========================================================================================================================================================
    // URLs
    // =========================================================================================================================================================
    /* tslint:disable:member-ordering */
    private get baseFoldersApiUrl(): string { return `${this.baseApiUrl}folders`; }
    getFolderUrl(id: number): string { return `${this.baseFoldersApiUrl}/${id}?includeBreadcrumbs=false`; }
    get createFolderUrl(): string { return `${this.baseFoldersApiUrl}`; }
    updateFolderUrl(id: number): string { return `${this.baseFoldersApiUrl}/${id}`; }
    get addPdfToFolderUrl(): string { return `${this.baseFoldersApiUrl}/addPdf`; }
    deleteFolderUrl(id: number): string { return `${this.baseFoldersApiUrl}/${id}`; }
    get deleteItemsUrl(): string { return `${this.baseFoldersApiUrl}/deleteItems`; }
    get moveItemsUrl(): string { return `${this.baseFoldersApiUrl}/moveItems`; }
}
